import styled from "styled-components"
import H3 from "../H3"
import { device } from "../../themes/device"
import theme from "../../themes"

const Title = styled(H3)`
  margin-bottom: 0;

  ${props => props.center && "text-align: center;"};
  ${props => props.right && "text-align: right;"};
`

export default Title
